var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.movie.isGuestExcluded)?_c('main',[_c('vue-headful',{attrs:{"title":_vm.dynamicTitle,"head":{
        'meta[name=\'robots\']': {
          name: 'robots',
          content: 'noindex',
        },
    }}}),_c('not-found')],1):_c('main',{staticClass:"movies"},[_c('vue-headful',{attrs:{"title":_vm.dynamicTitle,"head":{
        'meta[name=\'robots\']': {
          name: 'robots',
          content: 'index',
        },
    }}}),_c('video-player',{key:_vm.componentRefresh}),_c('movie-chapters'),_c('movie-options'),_c('div',{staticClass:"contents"},[_c('movie-info',{attrs:{"hide-release-date":_vm.hideOldReleaseDate}}),(!_vm.newXPEligible)?_c('download-menu'):_vm._e(),(!_vm.movie.isGuestExcluded)?_c('movie-gallery'):_vm._e(),_c('related-movies',{attrs:{"num-movies":6}}),(_vm.locale == 'ja')?_c('div',{staticClass:"movie-review section",attrs:{"id":"user-reviews"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('reviews')))]),_c('review-form'),_c('review-list')],1):_vm._e(),(_vm.hasCensoredSample)?_c('div',[_c('aff-embed')],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }